"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var InfoBarMessage_1 = require("./InfoBarMessage");
var InfoBar = /** @class */ (function (_super) {
    tslib_1.__extends(InfoBar, _super);
    function InfoBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoBar.prototype.render = function () {
        // VSO 1777: add collapse/expand behavior to info bar
        // VSO 1778: sort info messages in info bar based on ranks
        return this.props.messages.length > 0 ? (React.createElement("div", { className: this.props.className }, this.props.messages.map(function (message) { return (React.createElement(InfoBarMessage_1.default, tslib_1.__assign({ key: message.key }, message))); }))) : null;
    };
    InfoBar = tslib_1.__decorate([
        mobx_react_1.observer
    ], InfoBar);
    return InfoBar;
}(React.Component));
exports.default = InfoBar;
//# sourceMappingURL=InfoBar.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-info-bar/lib/components/InfoBar.js
// module id = 3106
// module chunks = 3 4 17